export default __webpack_public_path__ + "images/contrast.b967832.svg";